import { render, staticRenderFns } from "./smsLog.vue?vue&type=template&id=b20365c4&"
import script from "./smsLog.vue?vue&type=script&lang=js&"
export * from "./smsLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports